<template>
  <div class="home">
    <BannerSection />
    <JobListSection />
    <PickJobsSection />
    <UrgentJobsSection />
    <SubBanner />
    <PartnersSection />
    <NewJobsSection />
  </div>
</template>

<script>
import BannerSection from '@/components/home/BannerSection.vue'
import JobListSection from '@/components/home/JobListSection.vue'
import NewJobsSection from '@/components/home/NewJobsSection.vue';
import SubBanner from '@/components/home/SubBanner.vue';
import UrgentJobsSection from '@/components/home/UrgentJobsSection.vue';
import PartnersSection from '@/components/home/PartnersSection.vue';
import PickJobsSection from '@/components/home/PickJobsSection.vue';

export default {
  name: 'HomeView',
  components: {
    BannerSection,
    JobListSection,
    NewJobsSection,
    PickJobsSection,
    UrgentJobsSection,
    SubBanner,
    PartnersSection
  }
}
</script>

<style scoped>
.home {
  padding-bottom: 60px;
}
</style>